import { jsonldBrandName } from './JsonldStore';

export const updateJsonldBrandName = (value) => jsonldBrandName.update((oldValue) => value);

